import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useRoleContext } from '../hooks/useRoleContext';
import usePermissions from '../hooks/usePermissions';

const ProtectedPermissionRoute = ({ requiredPermission, redirectPath = '/unauthorized' }: any) => {
  const { role, aiPrivileges } = useRoleContext();
  const { hasPermission } = usePermissions();

  if (hasPermission(requiredPermission, role) && requiredPermission !== 'ai_privileges') {
    return <Outlet />;
  } else if (requiredPermission === 'ai_privileges' && ['admin'].includes(aiPrivileges)) {
    return <Outlet />;
  } else {
    return <Navigate to={redirectPath} replace />;
  }
};

export default ProtectedPermissionRoute;
